import { render, staticRenderFns } from "./PlaceServiceAreaEditor.vue?vue&type=template&id=5ddda574&scoped=true"
import script from "./PlaceServiceAreaEditor.vue?vue&type=script&lang=js"
export * from "./PlaceServiceAreaEditor.vue?vue&type=script&lang=js"
import style0 from "./PlaceServiceAreaEditor.vue?vue&type=style&index=0&id=5ddda574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddda574",
  null
  
)

export default component.exports